import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import BotDetails from "./pages/BotDetails";
import TOS from "./pages/TOS";
import Privacy from "./pages/Privacy";
import SupportUs from "./pages/SupportUs";
import About from "./pages/About";
import GDPR from "./pages/GDPR";
import Copyright from "./pages/Copyright";
import CookiePolicy from "./pages/CookiePolicy";
import Contact from "./pages/Contact";
import EndUserLicenseAgreement from "./pages/end-user-license-agreement"; // â¬…ï¸ NEW

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/bot/:id" element={<BotDetails />} />
            <Route path="/support-us" element={<SupportUs />} />
            <Route path="/about" element={<About />} />

            {/* Legal Pages */}
            <Route path="/tos" element={<TOS />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/gdpr" element={<GDPR />} />
            <Route path="/copyright" element={<Copyright />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route
              path="/end-user-license-agreement"
              element={<EndUserLicenseAgreement />}
            />
            {/* Short alias */}
            <Route path="/eula" element={<Navigate to="/end-user-license-agreement" replace />} />

            {/* Contact */}
            <Route path="/contact" element={<Contact />} />

            {/* Fallback (optional): redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
